module.exports = __webpack_public_path__ + "/public/images/e2713ad901664d4f5f1c166a07bcf2a1.png";